function sections_in_view() {
  const sections = document.querySelectorAll('.page-template-page-news-php main section');

  if( sections.length > 0 ) {
    document.addEventListener('scroll', event => {
      sections.forEach( element => {
        let id = element.getAttribute('id');
        var rect = element.getBoundingClientRect();
        // console.log(id);
        // console.log(is_element_in_viewport(element));
        // console.log(element.getBoundingClientRect());
        if( is_element_in_viewport(element) ) {
          document.querySelector('body').setAttribute('data-current-section',id);
        }
      });
    });
  }
}

sections_in_view();

function is_element_in_viewport(el) {
  var rect = el.getBoundingClientRect();
  let offset = 100;
  return (
    rect.top < offset
    // rect.left >= 0 &&
    // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
